'use strict';

var React = require('react'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    Icon = require('../atoms/Icon'),
    MediumEditor = require('medium-editor'),
    DraftActionCreators = require('../actions/DraftActionCreators'),
    EditorSectionMixin = require('../mixins/EditorSectionMixin'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    DragItemTypes = require('../constants/DragItemTypes'),
    EditorDragImages = require('../constants/EditorDragImages'),
    getThumbnailUrl = require('../utils/getThumbnailUrl'),
    { isIE } = require('../utils/Browser'),
    { DragDropMixin, ImagePreloaderMixin } = require('react-dnd'),
    { PropTypes } = React;

require('./legacy/Section.less');

var EditorText = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin, DragDropMixin, ImagePreloaderMixin, EditorSectionMixin],

  className: 'editor-Section editor-Section--text',

  propTypes: {
    uuid: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    onDeleteClick: PropTypes.func.isRequired,
    isNew: PropTypes.bool
  },

  getDefaultProps() {
    return {
      text: ''
    };
  },

  getInitialState() {
    return {
      text: this.props.text
    };
  },

  getSectionDragPreviewUrl() {
    var scale = this.getDragImageScale(),
        image = EditorDragImages.TEXT;

    return getThumbnailUrl(image, {
      mode: 'preview',
      width: Math.round(image.size.width / image.intendedScale * scale),
      height: Math.round(image.size.height / image.intendedScale * scale)
    });
  },

  getImageUrlsToPreload() {
    return [this.getSectionDragPreviewUrl()];
  },

  configureDragDrop(registerType) {
    registerType(DragItemTypes.SECTION, {
      dragSource: this.getSectionDragSource(this.getSectionDragPreviewUrl()),
      dropTarget: this.getSectionDropTarget()
    });
  },

  componentDidMount() {
    var iconHTML = React.renderToString(<Icon name='link' size='xsmall' mode='stroke' />),
        wysiwygEl = this.refs.wysiwyg.getDOMNode();

    this.textEditor = new MediumEditor([wysiwygEl], {
      cleanPastedHTML: true,
      placeholder: 'Add some text',
      anchorInputPlaceholder: 'Type a link',
      buttons: ['bold', 'italic', 'quote', 'anchor', 'header1'],
      buttonLabels: { 'anchor': iconHTML },
      diffLeft: 0,
      diffTop: 0,
      firstHeader: 'h3'
    });

    if (this.props.isNew) {
      this.getDOMNode().scrollIntoViewIfNeeded();
      wysiwygEl.focus();

      DraftActionCreators.resetLastAddedItem();
    }

    if (isIE() && typeof MutationObserver !== 'undefined') {
      this.observer = new MutationObserver(this.handleWysiwygInput);
      this.observer.observe(wysiwygEl, {
        attributes: true,
        childList: true,
        characterData: true,
        characterDataOldValue: true,
        subtree: true
      });
    }
  },

  componentWillUnmount() {
    this.textEditor.deactivate();

    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  },

  render() {
    var dragSectionState = this.getDragState(DragItemTypes.SECTION);

    return (
      <div className={this.getClassName()}
           data-dragging={dragSectionState.isDragging}
           {...this.dropTargetFor(DragItemTypes.SECTION)}>
        <div className='editor-Section-topBar'
             {...this.dragSourceFor(DragItemTypes.SECTION)}>
          <div className='editor-Section-type'>
            <Icon name='text' size='small' mode='stroke' />
            <span className='editor-Section-typeTitle'>Text</span>
          </div>

          <div className='editor-Section-delete'
               onClick={this.handleDeleteClick}>
            <Icon name='cross' size='xsmall' mode='stroke' />
          </div>
        </div>

        <div ref='wysiwyg'
             className='editor-Section-textEditor'
             onInput={this.handleWysiwygInput}
             dangerouslySetInnerHTML={{__html: this.state.text}} />
      </div>
    );
  },

  handleWysiwygInput() {
    var node = this.refs.wysiwyg.getDOMNode(),
        text = node.innerHTML;

    if (text === this.props.text) {
      return;
    }

    DraftActionCreators.updateSection(this.props.uuid, {
      text: text
    });
  },

  handleDeleteClick() {
    this.props.onDeleteClick(this.props.uuid, this.props.text.length > 0);
  }
});

module.exports = EditorText;



/** WEBPACK FOOTER **
 ** ./editor/EditorText.jsx
 **/